// ---------- dire pourquoi une couleur ne répond pas (alphabets joués dans l'ordre) ----------
// La peinture se joue couleur après couleur, sans choix (Alphabet.orderedPlay) : seule la
// pastille en cours répond, et une case d'une couleur à venir ne se peint pas. Sans un mot, le
// joueur le découvre par l'échec — une pastille qui ne répond pas, une case qui ne se remplit
// pas — et ça se lit comme une panne. La règle est donc dite au tap sur une pastille à venir,
// à chaque fois : le geste est délibéré, il mérite une réponse.
//
// Deux autres moments ont été retirés à la demande (2026-10-14) : une bulle à l'ouverture de la
// première feuille en peinture — une explication avant le premier tap est une explication qu'on
// n'a pas demandée —, et une au tap sur une case d'une couleur à venir — sur la feuille, une
// visée à côté reste muette, comme pour tous les alphabets (cf. paintAt). Le message restant
// porte donc la règle entière, pas seulement « plus tard ».
//
// Un module à part de coach.ts : celui-ci tient les leçons des GESTES, communes à tous les
// alphabets, avec leur propre ancrage (le disque de la boussole). Ici, un seul message posé au
// bas de la feuille. Le même habit (.coach), parce que c'est la même voix : l'application qui
// explique. Et comme lui, EN POSITION ABSOLUE DANS .sheetbox et sans prendre les taps : la
// feuille ne bouge pas et aucune case dessous ne devient impeignable.

import { noMotion } from './anim';
import { t } from './i18n';

/** Le temps de lire la réponse à un tap : deux phrases courtes. */
const LATER_MS = 4500;

let elt: HTMLElement | null = null;
let timer = 0;

function hide(): void {
  clearTimeout(timer);
  elt?.remove();
  elt = null;
}

function show(html: string, ms: number): void {
  hide();
  const box = document.querySelector('.sheetbox');
  if (!box) return;
  elt = document.createElement('div');
  elt.className = 'coach coach-ordre';
  elt.setAttribute('role', 'status');
  elt.setAttribute('aria-live', 'polite');
  if (noMotion()) elt.classList.add('coach-fixe');
  const text = document.createElement('span');
  text.className = 'coach-t';
  text.innerHTML = html;
  elt.appendChild(text);
  box.appendChild(elt);
  timer = window.setTimeout(hide, ms);
}

/** Une feuille s'ouvre : la bulle de la feuille d'avant s'en va. */
export function ordreNouvelleFeuille(): void {
  hide();
}

/** Un tap sur une pastille à venir. */
export function ordrePastilleAVenir(): void {
  show(t('ordre.later'), LATER_MS);
}
